import { React, useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { CRYPTO_SECRET_KEY, base_url } from "../utilities";
import { useNavigate } from "react-router";
import axios from "axios";
import { useEffect } from "react";
import CryptoJS from "crypto-js";
import { toast } from "react-toastify";

const UserInitialPasswordSetup = () => {
  const navigate = useNavigate();

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const user_email = window.location.href.split("?")[1];
  const [email, setEmail] = useState("");
  useEffect(() => {
    let bytes = CryptoJS.AES.decrypt(user_email, CRYPTO_SECRET_KEY);
    let email = bytes.toString(CryptoJS.enc.Utf8);
    setEmail(email);
    axios
      .post(base_url + "find/user", {
        email: email,
      })
      .then((res) => {
        if (res.data.data.is_password_set == 1) {
          navigate("/");
        }
      });
  }, []);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const isSaveButtonDisabled =
    newPassword !== confirmPassword ||
    newPassword.length < 8 ||
    !/(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_])/.test(newPassword);


  const handleConfirmPasswordChange = (event) => {
    setConfirmPassword(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (newPassword !== confirmPassword) {
      alert("Passwords do not match. Please re-enter.");
      return;
    }

    if (newPassword.length < 8) {
      alert("Password should be at least 8 characters long.");
      return;
    }

    if (!/(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_])/.test(newPassword)) {
      alert(
        "Password should contain at least 1 number, 1 uppercase character, 1 lowercase character, and 1 special character."
      );
      return;
    }
    axios
      .post(base_url + "password/update/initial/onborading", {
        email: email,
        password: newPassword,
      })
      .then((res) => {
        if (res.data.status == 200) {
          toast.success("Successfully saved the password", {
            toastId: 103,
          });
          setTimeout(() => {
            window.location.reload();
          });
          navigate("/");
        } else {
          toast.error(res.data.message, {
            toastId: 104,
          });
        }
      });
    alert("Password change successful!");
  };

  const [password, setPassword] = useState("");
  const [isValidLength, setIsValidLength] = useState(false);
  const [hasLowerCase, setHasLowerCase] = useState(false);
  const [hasUpperCase, setHasUpperCase] = useState(false);
  const [hasNumber, setHasNumber] = useState(false);
  const [hasSpecialCharacter, setHasSpecialCharacter] = useState(false);

  const handlePasswordChange = (event) => {
    const newPassword = event.target.value;
    setNewPassword(event.target.value);
    setPassword(newPassword);
    setIsValidLength(newPassword.length >= 8);
    setHasLowerCase(/[a-z]/.test(newPassword));
    setHasUpperCase(/[A-Z]/.test(newPassword));
    setHasNumber(/[0-9]/.test(newPassword));
    setHasSpecialCharacter(
      /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/.test(newPassword)
    );
  };

  const [not_match_Error,setNotMatchError]=useState("");

  useEffect(()=>{
    if(isSaveButtonDisabled && confirmPassword.length>0){
      setNotMatchError("* Password doesn't match");
    }
    else{
      setNotMatchError("");
    }
    
  },[isSaveButtonDisabled,confirmPassword])

  return (
    <>
      <div className="bg-image d-flex  flex-column justify-content-start">
        <div className="row">
          <div className=" p-5">
            <div className="mb-4 text_bd">
              <article className="text-center mt-4">
              <span className="text-primary text_bd">Congratulations!</span> You Are Successfully Registered. Please setup your Password
              </article>
            </div>
            <div className="text-center">
              <img
                // className="login_brand_img"
                src="./images/logo.svg"
                alt=""
                style={{ width: "200px" }}
              />
            </div>

            <div className="col-12 col-md-8  mt-5" style={{ margin: "auto" }}>
              <div className="forgot_container">
                <div className="card-body form-container">
                  <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                      <label htmlFor="newPassword" className="form-label">
                        Enter New Password
                      </label>
                      <input
                        type="password"
                        className="form-control"
                        id="psw"
                        name="psw"
                        onChange={handlePasswordChange}
                        value={password}
                        pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"
                        title="Must contain at least one number and one uppercase and lowercase letter, and at least 8 or more characters"
                        required
                      />
                    </div>

                    <div className={not_match_Error.length>0 ? "mb-1" :"mb-3"}>
                      <label htmlFor="confirmPassword" className="form-label">
                        Re-confirm Password
                      </label>
                      <div className="password-input-container">
                        <input
                          type={showPassword ? "text" : "password"}
                          className="form-control"
                          id="confirmPassword"
                          value={confirmPassword}
                          onChange={handleConfirmPasswordChange}
                        />
                        <span
                          className="password-toggle"
                          onClick={togglePasswordVisibility}
                        >
                          {showPassword ? <FaEyeSlash /> : <FaEye />}
                        </span>
                      </div>
                    </div>
                    {
              not_match_Error.length>0?
              <div className="text-danger mb-3" >{not_match_Error}</div>:""
            }
                    <div className="mb-3 d-grid">
                      <button
                        type="submit"
                        className="btn btn-warning text-white"
                        disabled={isSaveButtonDisabled}
                      >
                        Save
                      </button>
                      
                    </div>
                    
                  </form>
                  <div className="mt-4 d-md-none d-col-block">

<div id="message" className="message-box" >
  {!(
    isValidLength &&
    hasLowerCase &&
    hasUpperCase &&
    hasNumber && hasSpecialCharacter
  ) ? (
    <p className={`validation-message invalid text-black`} style={{fontSize:"10px"}}>
      <b>The password should meet the following criteria:</b>
    </p>
  ) : null}
  {!isValidLength ? (
    <p className={`validation-message invalid text-danger`} style={{fontSize:"10px"}}>
      ✖ Length must be at least 8 characters
    </p>
  ) : (
    <p className={`validation-message invalid text-success`} style={{fontSize:"10px"}}>
      ✔ Length must be at least 8 characters
    </p>
  )}
  {!hasLowerCase ? (
    <p className={`validation-message invalid text-danger`} style={{fontSize:"10px"}}>
      ✖ Must contain at least one lowercase letter
    </p>
  ) : (
    <p className={`validation-message invalid text-success`} style={{fontSize:"10px"}}>
      ✔ Must contain at least one lowercase letter
    </p>
  )}
  {!hasUpperCase ? (
    <p className={`validation-message invalid text-danger`} style={{fontSize:"10px"}}>
      ✖ Must contain at least one uppercase letter
    </p>
  ) : (
    <p className={`validation-message invalid text-success`} style={{fontSize:"10px"}}>
      ✔ Must contain at least one uppercase letter
    </p>
  )}
  {!hasNumber ? (
    <p className={`validation-message invalid text-danger`} style={{fontSize:"10px"}}>
      ✖ Must contain at least one number
    </p>
  ) : (
    <p className={`validation-message invalid text-success`} style={{fontSize:"10px"}}>
      ✔ Must contain at least one number
    </p>
  )}
  {!hasSpecialCharacter ? (
    <p className={`validation-message invalid text-danger`} style={{fontSize:"10px"}}>
      ✖ Must contain at least one special character
    </p>
  ) : (
    <p className={`validation-message invalid text-success`} style={{fontSize:"10px"}}>
      ✔ Must contain at least one special character
    </p>
  )}
  
</div>
</div>

                
                  </div>
            

                <div className="mt-4 d-none d-md-block">
                  <div id="message" className="message-box">
                    {!(
                      isValidLength &&
                      hasLowerCase &&
                      hasUpperCase &&
                      hasNumber && hasSpecialCharacter
                    ) ? (
                      <p className={`validation-message invalid text-black`}>
                        <b>The password should meet the following criteria:</b>
                      </p>
                    ) : null}
                    {!isValidLength ? (
                      <p className={`validation-message invalid text-danger`}>
                        ✖ Length must be at least 8 characters
                      </p>
                    ) : (
                      <p className={`validation-message invalid text-success`}>
                        ✔ Length must be at least 8 characters
                      </p>
                    )}
                    {!hasLowerCase ? (
                      <p className={`validation-message invalid text-danger`}>
                        ✖ Must contain at least one lowercase letter
                      </p>
                    ) : (
                      <p className={`validation-message invalid text-success`}>
                        ✔ Must contain at least one lowercase letter
                      </p>
                    )}
                    {!hasUpperCase ? (
                      <p className={`validation-message invalid text-danger`}>
                        ✖ Must contain at least one uppercase letter
                      </p>
                    ) : (
                      <p className={`validation-message invalid text-success`}>
                        ✔ Must contain at least one uppercase letter
                      </p>
                    )}
                    {!hasNumber ? (
                      <p className={`validation-message invalid text-danger`}>
                        ✖ Must contain at least one number
                      </p>
                    ) : (
                      <p className={`validation-message invalid text-success`}>
                        ✔ Must contain at least one number
                      </p>
                    )}
                    {!hasSpecialCharacter ? (
                      <p className={`validation-message invalid text-danger`}>
                        ✖ Must contain at least one special character
                      </p>
                    ) : (
                      <p className={`validation-message invalid text-success`}>
                        ✔ Must contain at least one special character
                      </p>
                    )}
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
      
      <div className="dBrand fixed-bottom">
        <h5>
          <img src="./images/brand_logo.svg" alt="" />
          <i>TrialTrak</i>
          <sup>
            <small>TM</small>
          </sup>{" "}
          Turnkey Learning 2023
        </h5>
      </div>
      
    </>
  );
};

export default UserInitialPasswordSetup;
